export default __webpack_public_path__ + "static/media/480_dummy2016-kunstshop01-mobile-de.d79360f3.png";